// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/*\n * Copyright 2020 Google LLC.\n * SPDX-License-Identifier: Apache-2.0\n */\n\n/* You can add global styles to this file, and also import other style files */\n", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,8EAA8E","file":"styles.css","sourcesContent":["/*\n * Copyright 2020 Google LLC.\n * SPDX-License-Identifier: Apache-2.0\n */\n\n/* You can add global styles to this file, and also import other style files */\n"]}]);
// Exports
module.exports = exports;
